(function () {
  // inventory_quantity is never exposed via public product JSON (product.variants |
  // json, /products/{handle}.js) — only via server-side Liquid. So variant switching
  // re-fetches this section's own markup with ?variant=<id> (Section Rendering API)
  // instead of computing anything client-side, keeping the low-stock line honest.
  document.querySelectorAll('[data-sv-buybox]').forEach(function (buybox) {
    var productUrl = buybox.getAttribute('data-product-url');
    var sectionId = buybox.getAttribute('data-section-id');
    var requiresSelection = buybox.getAttribute('data-requires-selection') === 'true';
    var pills = buybox.querySelectorAll('[data-sv-buybox-pill]');
    var pillsContainer = buybox.querySelector('[data-sv-buybox-pills]');

    // True immediately for single-variant/"One size" products (nothing to choose);
    // for real multi-size products, only flips true once the shopper taps a pill —
    // per spec: never silently add the server's default-selected variant to cart.
    var explicitlySelected = !requiresSelection;

    var UPDATE_SELECTORS = [
      '[data-sv-buybox-price]',
      '[data-sv-buybox-compare-price]',
      '[data-sv-buybox-discount]',
      '[data-sv-buybox-stock-note]'
    ];

    function setNote(text) {
      var noteEl = buybox.querySelector('[data-sv-buybox-stock-note]');
      if (!noteEl) return;
      noteEl.textContent = text || '';
      noteEl.hidden = !text;
    }

    function refreshFromServer(variantId) {
      var url = productUrl + '?variant=' + variantId + '&section_id=' + sectionId;

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sv-buybox]');
          if (!fresh) return;

          UPDATE_SELECTORS.forEach(function (selector) {
            var current = buybox.querySelector(selector);
            var updated = fresh.querySelector(selector);
            if (current && updated) current.outerHTML = updated.outerHTML;
          });

          // Re-fired now that price/stock-note reflect the real server data —
          // sv-sticky-atc.js's price sync depends on this DOM being fresh.
          // data-selected-variant-id itself is NOT set here; see the pill click
          // handler below for why.
          buybox.dispatchEvent(
            new CustomEvent('sv:variant-change', { detail: { variantId: variantId }, bubbles: true })
          );
        })
        .catch(function () {
          // Network hiccup — price/stock-note simply won't refresh until the next
          // successful click. The selected variant id itself is already correct
          // (set synchronously in the click handler below, not here), so Add to
          // Cart/Buy Now still submit the right item regardless of this request.
        });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var value = pill.getAttribute('data-value');

        if (pill.hasAttribute('data-soldout')) {
          setNote('Size ' + value + ' is out of stock right now.');
          return;
        }

        pills.forEach(function (p) {
          p.classList.remove('sv-pill--selected');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('sv-pill--selected');
        pill.setAttribute('aria-pressed', 'true');
        explicitlySelected = true;

        var variantId = pill.getAttribute('data-variant-id');
        if (variantId) {
          // Set + broadcast synchronously, before the price/stock-note refresh
          // below even starts, so Add to Cart/Buy Now/sticky ATC always submit
          // the variant that's actually visually selected — even if that fetch
          // is slow or fails outright. Previously this only updated once the
          // fetch resolved, which meant a tap on Add to Cart during a slow
          // request (a real risk on the mobile connections most of this
          // store's traffic uses) could silently add the wrong size.
          buybox.setAttribute('data-selected-variant-id', variantId);
          buybox.dispatchEvent(
            new CustomEvent('sv:variant-change', { detail: { variantId: variantId }, bubbles: true })
          );
          refreshFromServer(variantId);
        }
      });
    });

    // --- Delivery countdown (spec section 10, replaces the old pincode checker) ---
    // Operator-approved exception to CLAUDE.md's no-countdown-timer rule (recorded
    // there 2026-07-23), scoped narrowly: counts down to a REAL, schema-editable
    // daily cutoff clock time — not an arbitrary number that silently resets — and
    // the delivery date range is honestly computed from today + schema-editable
    // min/max days, not a real courier serviceability check (none integrated yet).
    var deliveryEl = buybox.querySelector('[data-sv-delivery-cutoff]');

    if (deliveryEl) {
      var deliveryTextEl = deliveryEl.querySelector('[data-sv-delivery-text]');
      var deliveryTemplate = deliveryEl.getAttribute('data-sv-delivery-template') || '[countdown] · [date_range]';
      var deliveryMinDays = parseInt(deliveryEl.getAttribute('data-sv-delivery-min-days'), 10) || 4;
      var deliveryMaxDays = parseInt(deliveryEl.getAttribute('data-sv-delivery-max-days'), 10) || 6;
      var cutoffParts = (deliveryEl.getAttribute('data-sv-delivery-cutoff') || '18:00').split(':');
      var cutoffHours = parseInt(cutoffParts[0], 10);
      var cutoffMinutes = parseInt(cutoffParts[1], 10);
      if (isNaN(cutoffHours)) cutoffHours = 18;
      if (isNaN(cutoffMinutes)) cutoffMinutes = 0;

      function pad2(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function nextCutoff() {
        var now = new Date();
        var next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHours, cutoffMinutes, 0, 0);
        if (next <= now) next.setDate(next.getDate() + 1);
        return next;
      }

      function formatCountdown(ms) {
        var totalSeconds = Math.max(0, Math.floor(ms / 1000));
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        if (hours > 0) return hours + ':' + pad2(minutes) + ':' + pad2(seconds);
        return pad2(minutes) + ':' + pad2(seconds);
      }

      function formatDate(date) {
        return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
      }

      function deliveryDateRangeText() {
        var minDate = new Date();
        minDate.setDate(minDate.getDate() + deliveryMinDays);
        if (deliveryMinDays === deliveryMaxDays) return formatDate(minDate);
        var maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + deliveryMaxDays);
        return formatDate(minDate) + ' – ' + formatDate(maxDate);
      }

      function renderDelivery() {
        var msLeft = nextCutoff().getTime() - Date.now();
        var text = deliveryTemplate
          .replace(/\[\s*countdown\s*\]/, formatCountdown(msLeft))
          .replace(/\[\s*date_range\s*\]/, deliveryDateRangeText());
        deliveryTextEl.textContent = text;
      }

      renderDelivery();
      setInterval(renderDelivery, 1000);
    }

    // --- CTA buttons (spec section 11) ---------------------------------------
    var addToCartBtn = buybox.querySelector('[data-sv-buybox-add-to-cart]');
    var buyNowBtn = buybox.querySelector('[data-sv-buybox-buy-now]');
    var ctaError = buybox.querySelector('[data-sv-buybox-cta-error]');

    // Breeze checkout handles Buy now by programmatically clicking Add to cart, then
    // opening its own checkout. Window-capture runs before Breeze's document-capture
    // listener, so we can tell that click apart from a real Add to cart tap.
    var lastBuyNowClick = 0;
    window.addEventListener('click', function (event) {
      if (buyNowBtn && buyNowBtn.contains(event.target)) lastBuyNowClick = Date.now();
    }, true);

    function setCtaError(text) {
      if (!ctaError) return;
      ctaError.textContent = text || '';
      ctaError.hidden = !text;
    }

    function pulseSizeSelector() {
      if (!pillsContainer) return;
      pillsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      pillsContainer.classList.add('sv-pulse');
      setTimeout(function () {
        pillsContainer.classList.remove('sv-pulse');
      }, 700);
    }

    function updateHeaderCartCount() {
      fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var cartLink = document.querySelector('.sv-header__icon[aria-label="Cart"]');
          if (!cartLink) return;
          var countEl = cartLink.querySelector('.sv-header__cart-count');
          if (cart.item_count > 0) {
            if (!countEl) {
              countEl = document.createElement('span');
              countEl.className = 'sv-header__cart-count';
              cartLink.appendChild(countEl);
            }
            countEl.textContent = cart.item_count;
          }
        });
    }

    function addToCart(onSuccess) {
      var variantId = buybox.getAttribute('data-selected-variant-id');
      setCtaError('');

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Could not add to cart.');
            });
          }
          return response.json();
        })
        .then(function (item) {
          updateHeaderCartCount();
          if (onSuccess) onSuccess(item);
        })
        .catch(function (error) {
          setCtaError(error.message);
        });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        if (requiresSelection && !explicitlySelected) {
          pulseSizeSelector();
          return;
        }

        // Click came from Breeze's Buy now flow: add quietly (no label change, no
        // cart drawer) so the customer goes straight to checkout.
        if (Date.now() - lastBuyNowClick < 1000) {
          addToCart();
          return;
        }

        addToCartBtn.disabled = true;
        var originalText = addToCartBtn.textContent;
        addToCartBtn.textContent = 'Adding…';

        addToCart(function () {
          addToCartBtn.textContent = 'Added to cart ✓';
          document.dispatchEvent(new CustomEvent('sv:cart:updated'));
          setTimeout(function () {
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
          }, 1500);
        }).finally(function () {
          if (addToCartBtn.textContent === 'Adding…') {
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
          }
        });
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (requiresSelection && !explicitlySelected) {
          pulseSizeSelector();
          return;
        }

        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Redirecting…';

        addToCart(function (item) {
          // Checkout hook: a third-party checkout (e.g. Breeze) can listen for this
          // event and call event.preventDefault() to take over. If nothing handles
          // it, fall back to the native Shopify checkout so Buy now never dead-ends.
          var checkoutEvent = new CustomEvent('sv:buy-now', {
            cancelable: true,
            detail: { item: item, variantId: buybox.getAttribute('data-selected-variant-id') }
          });
          if (document.dispatchEvent(checkoutEvent)) {
            window.location.href = '/checkout';
          } else {
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = 'Buy now';
          }
        }).finally(function () {
          // Only re-enable on failure — on success the page is navigating away.
          if (!ctaError.hidden) {
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = 'Buy now';
          }
        });
      });
    }
  });
})();
